<template>
  <section
    :class="[
      'search',
      'search_bar',
      noIcon && 'no_icon',
      bigStyle && 'bigStyle',
    ]"
  >
    <input
      v-if="onlyNumber"
      oninput="value = value.replace(/[^\d]/g, '')"
      type="number"
      :value="value"
      @input="change"
      @keydown.enter="submit"
      :placeholder="placeholder"
      :maxlength="maxlength"
    />
    <input
      v-else
      type="text"
      :value="value"
      @input="change"
      @keydown.enter="submit"
      :placeholder="placeholder"
      :maxlength="maxlength"
    />
    <template v-if="value !== ''">
      <i class="close" @click="clear" v-if="showClear"></i>
      <div class="btn" @click="submit" v-if="showSearch">搜索</div>
    </template>
  </section>
</template>
<script>
export default {
  props: {
    showClear: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    // 适老化放大
    bigStyle: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxlength: {
      type: [Number, String, undefined],
      default: undefined,
    },
    onlyNumber: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    change(e) {
      let value = e.target.value
      this.$emit('input', value)
    },
    submit() {
      this.$emit('search', this.value)
    },
    clear() {
      this.$emit('input', '')
      this.$emit('search', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.search {
  height: 40px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 12px;
  overflow: hidden;
  box-sizing: border-box;
  &.no_icon {
    &::before {
      display: none !important;
    }
  }
  &:before {
    content: '';
    width: 18px;
    height: 18px;
    background: url('~@/assets/images/agent/search_s.png');
    background-size: 100% 100%;
    margin-right: 8px;
  }
  input {
    flex: 1;
    min-width: 0;
    color: #202124;
    &::placeholder {
      color: rgba(32, 33, 36, 0.5);
      font-size: 13px;
    }
  }
  i.close {
    position: static;
    width: 14px;
    height: 14px;
    background: url('~@/assets/images/agent/search_close.png');
    background-size: 100% 100%;
    margin-right: 12px;
  }
  .btn {
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 2px solid rgba(237, 239, 242, 0.5);
    height: 24px;
    color: #006cff;
    font-size: 12px;
    font-weight: bold;
  }
}
.bigStyle {
  input {
    &::placeholder {
      font-size: var(--set-font-size13);
    }
  }
  .btn {
    font-size: var(--set-font-size12);
  }
}
</style>
